$('.cta1').on('mouseover', function(){
	$('.hover-1').addClass('show');
})

$('.cta1').on('mouseout', function(){
	$('.hover-1').removeClass('show');
})

$('.cta2').on('mouseover', function(){
	$('.hover-2').addClass('show');
})

$('.cta2').on('mouseout', function(){
	$('.hover-2').removeClass('show');
})

$('.cta3').on('mouseover', function(){
	$('.hover-3').addClass('show');
})

$('.cta3').on('mouseout', function(){
	$('.hover-3').removeClass('show');
})

$('.cta4').on('mouseover', function(){
	$('.hover-4').addClass('show');
})

$('.cta4').on('mouseout', function(){
	$('.hover-4').removeClass('show');
})